import { render, staticRenderFns } from "./LinksExternos.vue?vue&type=template&id=ec9b5c74"
import script from "./LinksExternos.vue?vue&type=script&lang=js"
export * from "./LinksExternos.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports